/* eslint-disable no-control-regex -- Reject URL control characters before browser normalization. */
export function authReturnPath(value, fallback = '/') {
  if (
    typeof value !== 'string' ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    /[\\\u0000-\u0020\u007f]/.test(value)
  )
    return fallback;
  try {
    const u = new URL(value, 'https://postpop.invalid');
    if (
      u.origin !== 'https://postpop.invalid' ||
      /^\/(login|signup|signup-detail)(\/|$)/.test(decodeURIComponent(u.pathname))
    )
      return fallback;
    return u.pathname + u.search + u.hash;
  } catch {
    return fallback;
  }
}
export function socialUrl(value) {
  try {
    const u = new URL(value);
    return u.protocol === 'https:' && !u.username && !u.password ? u.href : null;
  } catch {
    return null;
  }
}
export function loginError(error, fallback) {
  const d = error?.response?.data;
  const message = d?.error?.message ?? d?.message ?? d?.msg;
  return typeof message === 'string' && message.trim() ? message : fallback;
}
export function validateLoginUser(data, t) {
  if (data?.isActive === false) throw new Error(t('auth.inactiveAccount'));
  if (typeof data?.token !== 'string' || !data.token.trim() || data?.id == null)
    throw new Error(t('auth.noLoginToken'));
  return data;
}
